import { z } from 'zod';

/**
 * @openapi
 * components:
 *   schemas:
 *     UpdateUserDto:
 *       type: object
 *       properties:
 *         name:
 *           type: string
 *           description: The name of the user
 *       required:
 *         - name
 */
export const updateUserDto = z.object({
  name: z.string().min(1),
});

export type UpdateUserDto = z.infer<typeof updateUserDto>;
